<template>
    <rkm-overlay>
        <rkm-layout-body title="Exportação">
            <template v-slot:actions>
                <rkm-button
                    @click="handleExit"
                    color="danger"
                >
                    Sair
                </rkm-button>
            </template>

            <rkm-layout-content>
                <Form
                    @exit="handleExit"
                    ref="Form"
                />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>

// Components.
import Form from "@/components/atencao-basica/exportacao/Form";

// Mixins
import { repository, error, object, data } from '@/mixins'

export default {
    components: { Form },
    created() {

        this.repositories = {
            impressao: this.getConectaSusRepository('impressao.atencaoBasica')
        }
    },
    data: () => ({
        cadastro: false,
    }),
    methods: {
        handleExit() {

            this.$router.push({ name: 'dashboard' })
        },
    },
    mixins: [repository, error, object, data],
}
</script>